import { get } from 'lodash-es'

import { validationErrorTranslationMap } from '../helper/validation-error-translation'

export default {
  computed: {
    formErrorStrings() {
      return this.formErrors.map(error => {
        // complaintForm.ticket.validation.errorType.email_address
        // complaintForm.ticket.validation.errorType.is_numeric
        // complaintForm.ticket.validation.errorType.not_empty
        // complaintForm.ticket.validation.errorType.undefined
        // complaintForm.ticket.validation.errorType.1
        return this.$t(`complaintForm.ticket.validation.errorType.${error.key}`, {
          field: this.$t(get(validationErrorTranslationMap, error.value)),
        })
      })
    },
  },
}
